export const apiUrl = process.env.NODE_ENV === "production" ? "/api" : "http://localhost:3000/api";
export const socketUrl = process.env.NODE_ENV === "production" ? "" : "http://localhost:3050";
export const locale = "tr";
